module.exports = __webpack_public_path__ + "img/pen.c2e6eab7.svg";